import {
    DEFAULT_CLIENT_CONFIG,
    getEnvInfo,
    getPortalEndpoint,
} from "../configurations";
import { useMemo } from "react";
import { ErmineServerSideRenderingService } from "@amzn/ermine-ssr-sdk";

export const useGetErmineSsrClient = () => {
    let portalEndpoint = getPortalEndpoint();
    if (process.env.NODE_ENV === "development") {
        portalEndpoint = window.location.origin;
    }

    const ermineSsrServiceClient = useMemo(() => {
        const { region } = getEnvInfo();

        return new ErmineServerSideRenderingService({
            ...DEFAULT_CLIENT_CONFIG,
            region: region,
            endpoint: portalEndpoint,
            httpOptions:
                process.env.NODE_ENV === "development"
                    ? {
                          xhrWithCredentials: true, // To control cookies and auth headers in browser CORS requests when using a proxy local server.
                      }
                    : undefined,
        });
    }, [portalEndpoint]);

    return {
        ermineService: ermineSsrServiceClient,
        isServiceReady: ermineSsrServiceClient != null,
    };
};
